import antd from 'ant-design-vue/es/locale-provider/it_IT';
import dayjsLocale from 'dayjs/locale/it';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/it.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'it',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
